'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ArrowLeft, Home, Search } from 'lucide-react';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-6">
      {/* Grid background */}
      <div
        className="fixed inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px',
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 text-center max-w-md">
        {/* 404 number */}
        <p className="text-[10rem] font-black text-white/5 leading-none select-none" aria-hidden="true">
          404
        </p>

        <div className="-mt-8">
          <h1 className="text-2xl font-black text-white tracking-tight mb-3">
            Página no encontrada
          </h1>
          <p className="text-sm text-white/50 leading-relaxed mb-8">
            La página que buscas no existe o fue movida. Puedes regresar al inicio o buscar un proveedor.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => router?.back()}
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-white/20 text-white text-sm font-semibold rounded-xl hover:border-white/40 hover:bg-white/5 transition-all active:scale-95"
            >
              <ArrowLeft size={15} aria-hidden="true" />
              Volver atrás
            </button>

            <Link
              href="/"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-white text-black text-sm font-semibold rounded-xl hover:bg-white/90 transition-all active:scale-95"
            >
              <Home size={15} aria-hidden="true" />
              Ir al inicio
            </Link>

            <Link
              href="/search"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-white/20 text-white text-sm font-semibold rounded-xl hover:border-white/40 hover:bg-white/5 transition-all active:scale-95"
            >
              <Search size={15} aria-hidden="true" />
              Buscar proveedores
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}